import {ReactNode} from "react"
import {classNames} from "@/library/utilities/html"

type AlertProps = {
    color?: 'normal' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'error'
    children?: ReactNode
    message?: string
}

export default function Alert(props: AlertProps) {
    const {color = 'normal', message, children} = props

    return <div className={classNames("alert", `alert--${color}`)}>
        {children ?? message}
    </div>
}
